module.exports = __webpack_public_path__ + "static/media/dutyFreeItems.e551a308.svg";